<form nz-form class="form" nzLayout="horizontal">
  <!-- <div class="drawer-form-wrapper"> -->
  <nz-table
    *ngIf="!isDataSheet"
    #basicTable
    [nzData]="categoryData"
    [nzScroll]="{ x: '597px', y: 'calc(100vh - 300px)' }"
    [nzFrontPagination]="false">
    <thead>
      <tr>
        <th nzWidth="150px">Behavior</th>
        <th nzWidth="400px">Sub Category</th>
        <th nzWidth="100px">Created Date</th>
        <th nzWidth="100px">Status</th>
        <th nzWidth="80px" nzAlign="center">Select</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
        <tr>
          <td [title]="data.behaviorCategoryName">
            {{ data.behaviorCategoryName }}
          </td>
          <td [title]="getSubcategory(data)">{{ getSubcategory(data) }}</td>
          <td>{{ data.resourceAddedDate | userDate: 'MM/dd/yyyy' }}</td>
          <td nzAlign="center">
            <div class="status active" *ngIf="data.statusId === 1">
              <span>Active</span>
            </div>
            <div class="status closed" *ngIf="data.statusId !== 1">
              <span>Closed</span>
            </div>
          </td>
          <td nzWidth="80px" nzAlign="center">
            <nz-radio-group
              id="select"
              [nzName]="'radiogroup' + data.id"
              class="justify-content-center"
              [(ngModel)]="selectedBehvaior"
              [ngModelOptions]="{ standalone: true }">
              <span nz-radio [nzValue]="data"> </span>
            </nz-radio-group>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
  <app-data-sheet
    [caseParams]="dataSheetParams"
    *ngIf="isDataSheet"></app-data-sheet>
  <div
    class="display-flex justify-content-between action-button-wrapper"
    *ngIf="categoryData.length > 1">
    <div class="footer-left">
      <button
        nz-button
        type="button"
        nzType="default"
        (click)="onBack()"
        [disabled]="!isDataSheet">
        Back
      </button>
    </div>
    <div class="footer-right">
      <button
        nz-button
        type="button"
        nzType="primary"
        (click)="goToNext()"
        [disabled]="!selectedBehvaior.id || isDataSheet">
        Next
      </button>
    </div>
  </div>
  <!-- </div> -->
</form>
